import { render, staticRenderFns } from "./InsuranceSubprogramCreatePageDMS.vue?vue&type=template&id=5e3b6920&scoped=true"
import script from "./InsuranceSubprogramCreatePageDMS.vue?vue&type=script&lang=js"
export * from "./InsuranceSubprogramCreatePageDMS.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSubprogramCreatePageDMS.vue?vue&type=style&index=0&id=5e3b6920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b6920",
  null
  
)

export default component.exports